"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function sky(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M18.0203 10.3523L14.4113 18.375H12.969L16.7677 9.93C17.2056 10.001 17.6288 10.1437 18.0203 10.3523ZM11.7053 5.63925L6.153 17.9835C4.737 17.3115 3.75 15.8392 3.75 14.1247C3.75 11.7772 5.5965 9.87525 7.875 9.87525C7.875 7.629 9.5655 5.79525 11.7053 5.63925ZM16.1257 9.87525L12.3015 18.375H10.7393L15.5408 7.7025C15.9105 8.3385 16.1257 9.0795 16.1257 9.87525ZM17.5463 18.1117L19.9958 12.6697C20.1577 13.1257 20.25 13.6147 20.25 14.127C20.25 15.9555 19.125 17.5132 17.5463 18.1117ZM18.6278 10.7512C18.9697 11.0212 19.2728 11.3422 19.5173 11.7105L16.5278 18.354C16.3942 18.3682 16.26 18.3752 16.1257 18.375H15.1987L18.6278 10.7512ZM12.015 5.625C12.6 5.62725 13.1542 5.7555 13.6575 5.98575L8.085 18.375H7.875C7.3575 18.375 6.8625 18.273 6.40725 18.0922L12.015 5.625ZM15.2153 7.2135L10.194 18.375H8.5095L14.0048 6.16125C14.4713 6.42975 14.8823 6.78825 15.2153 7.2135Z", fill: color }));
}
exports["default"] = sky;
//# sourceMappingURL=sky.js.map